/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import "./import-data.js";
import "./manage-events.js";
import "./manage-shared-sites.js";
import "./manage-surveys.js";
import "./manage-users.js";
import "./reports.js";

import ko from "knockout";
import birdata from "../../api.js";
import _ from "underscore";
import util from "util/util.js";

if(localStorage.isAdmin === 'true') {
	document.body.classList.add("is-admin");
}

birdata.me(true).noLoginRedirect()
	.catch(function() {})
	.then(function(me) {
		var isAdmin = !!(me && (me.is_administrator || _.findWhere(me.permissions, { role: "admin" })));
		if(isAdmin) {
			document.body.classList.add("is-admin");
		} else {
			document.body.classList.remove("is-admin");
		}
		localStorage.isAdmin = JSON.stringify(isAdmin);
	});

function AdminViewModel(params) {
	document.body.classList.add("birdata-fullscreen");

	var self = this;

	self.loaded = ko.observable(false);
	self.isAdmin = ko.observable(false);

	self.me = ko.observable();
	birdata.me().then(function(me) {
		self.me(me);
		self.isAdmin(me.is_administrator || _.findWhere(me.permissions, { role: "admin" }));
		setupHistory();
		self.loaded(true);
	});

	var allItems = [
		{
			title: "Import Data",
			component: "import-data",
			id: "import_data",
			filter: function() {
				return self.me() && self.me().is_administrator;
			}
		},
		{
			title: "Manage Events",
			component: "manage-events",
			id: "manage_events"
		},
		{
			title: "Manage Users",
			component: { name: "manage-users", params: { me: self.me }},
			id: "manage_users"
		},
		{
			title: "Manage Surveys",
			component: "manage-surveys",
			id: "manage_surveys"
		},
		{
			title: "Manage Shared Sites",
			component: "manage-shared-sites",
			id: "manage_shared_sites"
		},
		{
			title: "Reports",
			component: "reports",
			id: "reports",
			filter: function() {
				return self.me() && self.me().is_administrator;
			}
		}
	];

	self.menuItems = ko.pureComputed(function() {
		return _.filter(allItems, function(item) {
			return item.filter ? item.filter() : true;
		});
	});

	self.currentItem = ko.observable(null);

	self.selectItem = function() {
		self.currentItem(this);
		window.location.hash = util.encodeParams({ section : this.id });
	};

	function setupHistory() {
		window.addEventListener('hashchange', handleHashChange);
		handleHashChange();
	}

	function handleHashChange() {
		var section = _.findWhere(allItems, { id: util.hashParams().section });

		if(section && (section.filter ? section.filter() : true)) {
			self.currentItem(section);
		} else {
			self.currentItem(null);
		}
	}
}

ko.components.register('admin', {
	viewModel: function(params) {
		return new AdminViewModel(params);
	},
	template: require('../../../templates/admin/admin.html')
});
